import * as React from "react"
import { SVGProps } from "react"

const XIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#fff"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="#fff"
    className="w-6 h-6"
    {...props}
  >
    <title>Close</title>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 19.5 15-15m-15 0 15 15"
    />
  </svg>
)

export default XIcon
